import { render, staticRenderFns } from "./GSchoolClassBulkMoveModal.vue?vue&type=template&id=8e37bdf0&scoped=true&"
import script from "./GSchoolClassBulkMoveModal.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassBulkMoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e37bdf0",
  null
  
)

export default component.exports